<template>
  <div class="exam-uniform-batch-exam-info"
       v-loading="loading">
    <template v-if="editInfo">
      <div class="body"
           v-loading="committing"
           element-loading-text="数据提交中，请稍等...">
        <div class="info-wrap">
          <AmEditor v-model="form.examNote"
                    size="mini"
                    editor-height="276px"
                    placeholder="暂未设置考试须知"></AmEditor>
        </div>
      </div>
      <div class="footer">
        <el-button size="mini"
                   type="primary"
                   :disabled="committing"
                   @click="handleApply">提交保存</el-button>
        <el-button size="mini"
                   type="default"
                   @click="handleClose">关闭窗口</el-button>
      </div>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>统考数据加载失败</div>
        <el-button type="text"
                   @click="loadEditInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import AmEditor from '../../../../../../../elements/editor/AmEditor'
import Hint from '../../../../../../../elements/Hint'
export default {
  name: 'ExamUniformBatchExamInfo',
  components: {
    AmEditor,
    Hint
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      editInfo: null,
      form: {
        examNote: ''
      },
      committing: false
    }
  },
  methods: {
    loadEditInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/exam/uniform/batch/editInfo',
        method: 'post',
        data: this.$qs.stringify({
          postId: this.rowData.id
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.editInfo = response.data['editInfo'] || {}
              break
            }
            default: {
              this.$message.error(response.data['message'])
              break
            }
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleApply () {
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/exam/uniform/batch/setEditInfo',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          postId: this.rowData.id
        }, this.form))
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.$nextTick(() => {
                this.$emit('hidePopoverAndRefresh')
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    },
    handleClose () {
      this.$emit('hidePopover')
    }
  },
  mounted () {
    this.loadEditInfo()
  },
  watch: {
    visible (val) {
      if (val) {
        this.loadEditInfo()
      }
    },
    editInfo (val) {
      if (val) {
        Object.keys(this.form).forEach(key => {
          this.form[key] = val[key] || ''
        })
      }
    }
  }
}
</script>

<style lang="scss">
  .exam-uniform-batch-exam-info {
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .body {
      flex: auto;
      .info-wrap {
        padding: 15px;
      }
    }
    & > .footer {
      flex: none;
      height: 52px;
      background-color: #fff;
      border-top: 1px solid rgba(0,0,0,.05);
      text-align: center;
      line-height: 50px;
    }
  }
</style>
